import React from 'react';
import PropTypes from 'prop-types';
import { SortButton } from './SortButton';
import styles from './AggregateHeaderCell.module.css';

/**
 * Aggregate header cell component for Category Total and Course Total columns.
 *
 * Behavior matches assignment headers:
 * - Clicking the cell label does NOT trigger sorting
 * - Only clicking the sort button triggers column sorting
 */
export function AggregateHeaderCell({ columnId, label, sortState, onSort }) {
  // Get label text for aria-label (handle React nodes like <b>Name</b>)
  const labelText = typeof label === 'string' ? label : 'column';

  return (
    <div className={styles.container}>
      <span className={styles.label}>{label}</span>
      {columnId && onSort && (
        <div className={styles.sortButtonContainer}>
          <SortButton
            columnId={columnId}
            sortState={sortState}
            onSort={onSort}
            assignmentName={labelText}
          />
        </div>
      )}
    </div>
  );
}

AggregateHeaderCell.propTypes = {
  columnId: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  sortState: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  onSort: PropTypes.func,
};

AggregateHeaderCell.defaultProps = {
  sortState: false,
  onSort: null,
};
